import httpClient from '@/api/httpClient'
import Vue from 'vue'

export const ATLAS_BASE_ROUTE = '/c/etc/default.php'

export const getAtlasInfo = async (path) => {
  if (Vue.prototype.atlasInfoFetched && window.store.state?.InfoStore?.info) {
    return window.store.state?.InfoStore?.info
  }
  const response = await httpClient.get('atlas-info?path=' + encodeURIComponent(path)).catch(error => {
    Vue.config.errorHandler(error)
    if (process.env.VUE_APP_WORKING_ENV !== 'production') {
      console.log('atlas-info error: ', error)
    }
    if (!['development', 'dev', 'local'].includes(process.env.VUE_APP_WORKING_ENV) &&
      window.location.pathname !== ATLAS_BASE_ROUTE) {
      window.location.href = ATLAS_BASE_ROUTE
    }
  })
  const data = response?.data?.data || {}

  window.store.commit('InfoStore/SET_INFO', data)

  if (process.env.NODE_ENV === 'production' && !process.env.VUE_APP_IS_PUBLIC &&
    typeof data === 'object' && data.LOU_CUSTOMER_ID && typeof data.extra_user_attributes === 'object' &&
    typeof data.extra_user_attributes.person_id === 'number' && data.extra_user_attributes.person_id > 0) {
    const scriptTag = document.createElement('script')
    scriptTag.addEventListener('load', function() {
      if (typeof window.LOU === 'object' && typeof window.LOU.identify === 'function') {
        try {
          window.LOU.identify(data.extra_user_attributes.person_id.toString(), {
            ...data.extra_user_attributes,
            isAuthenticated: true,
            isAdmin: data.user.isAdmin,
            isSuperAdmin: data.user.isSuperAdmin,
            isLessonManager: data.user.isLessonManager || false
          })
        } catch (error) {
          Vue.config.errorHandler(error)
        }
      }
    })
    scriptTag.src = `//run.louassist.com/v2.5.1-m?id=${data.LOU_CUSTOMER_ID}`
    document.head.appendChild(scriptTag)
  }
  Vue.prototype.atlasInfoFetched = true
  return data
}
